import { useEffect, useState } from 'react'
import {
  getStoredBarItemsOrFallback,
  type BarMenuCategory,
  type BarMenuItem,
} from '@/lib/barMenuItems'

export function useBarMenuItems(
  category: BarMenuCategory,
  fallback: BarMenuItem[]
): BarMenuItem[] {
  const [items, setItems] = useState<BarMenuItem[]>(fallback)

  useEffect(() => {
    setItems(getStoredBarItemsOrFallback(category, fallback))
  }, [category, fallback])

  return items
}
